namespace $ {

	const income_packs = new WeakMap< Uint8Array< ArrayBuffer >, $giper_baza_pack >

	export function $shm_hitalama_app_pass_income_patch() {
		const yard = $giper_baza_glob.yard() as $rise_baza_patch_yard & {
			$shm_hitalama_app_pass_income_orig?: $rise_baza_patch_yard['port_income']
		}

		if( yard.$shm_hitalama_app_pass_income_orig ) return

		const income_orig = yard.$shm_hitalama_app_pass_income_orig = yard.port_income
		yard.port_income = function( port: $mol_rest_port, msg: Uint8Array< ArrayBuffer > ) {
			let pack = income_packs.get( msg )
			if( !pack ) income_packs.set( msg, pack = $giper_baza_pack.from( msg ) )
			const current = this.$.$giper_baza_auth.current().pass()
			for( const [ land_id, part ] of pack.parts() ) {
				const land = this.$.$giper_baza_glob.Land( new $giper_baza_link( land_id ) )
				for( const unit of part.units ) {
					if( !( unit instanceof $giper_baza_unit_gift ) || !unit.mate().str ) continue
					const mate = unit.mate()
					// A newly published area can omit a Pass already known on the
					// map's root land. Reuse that verified public key before applying
					// inherited grants, without requiring the participant's home land.
					const pass = current.lord().str === mate.str
						? current
						: land.lord_pass( mate )
							?? this.$.$giper_baza_glob.Land( land.link().lord() ).lord_pass( mate )
							?? this.$.$giper_baza_glob.Land( mate ).lord_pass( mate )
					if( pass ) land.pass_add( pass )
				}
			}
			return income_orig.call( this, port, msg )
		}
	}

}
